import React, { DetailedHTMLProps, HTMLAttributes } from 'react';

import { IAmpProps } from '../../typings/amp';

export interface IAmpYoutubeProps extends IAmpProps, DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
  videoId?: string;
}

const AmpYoutube: React.FC<IAmpYoutubeProps> = ({
  videoId = '',
  width = '100',
  height = '100',
  layout = 'fixed',
  dataBlockOnConsent,
}) => (
  <amp-youtube
    data-videoid={videoId}
    width={width}
    height={height}
    layout={layout}
    data-block-on-consent={dataBlockOnConsent ? '' : undefined}
  />
);

export default AmpYoutube;
